import type { Breakpoint } from '@hivebrite/design-system/Theme';

import { SLIDER_TYPES } from 'hb-builder/components/BuilderComponents/dynamic/Slider/SliderLayouts/types';

const INCREASE_TO_XL_CARD_NUMBER_DISPLAY: Breakpoint = {
  s: 1,
  m: 2,
  l: 3,
  xl: 4,
};

const INCREASE_TO_L_CARD_NUMBER_DISPLAY: Breakpoint = {
  s: 1,
  m: 2,
  l: 3,
  xl: 3,
};

export const perPageBreakpoints: Record<
  Exclude<SLIDER_TYPES, 'empty'>,
  Breakpoint
> = {
  [SLIDER_TYPES.DISCUSSIONS]: INCREASE_TO_XL_CARD_NUMBER_DISPLAY,
  [SLIDER_TYPES.EVENTS]: INCREASE_TO_XL_CARD_NUMBER_DISPLAY,
  [SLIDER_TYPES.NEWS]: INCREASE_TO_L_CARD_NUMBER_DISPLAY,
  [SLIDER_TYPES.POSTS]: INCREASE_TO_L_CARD_NUMBER_DISPLAY,
  [SLIDER_TYPES.TOPICS]: INCREASE_TO_XL_CARD_NUMBER_DISPLAY,
  [SLIDER_TYPES.USERS]: {
    s: 2,
    m: 4,
    l: 4,
    xl: 6,
  },
};
